<template>
    <div class="self-label">
        {{$t('nickname')}}
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          popper-class="nickname-tips"
        >
            <div class="" :style="{width: tipsWidth}" slot="content">
              {{$t('After_the_nickname_is_set_no_modification_is_allowed')}}
            </div>
            <i class="el-icon-info tips-icon"></i>
        </el-tooltip>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
  export default {
    name: 'nicknameTips',
    computed: {
      ...mapGetters(['realMobile']),
      tipsWidth(){
        if(!this.realMobile){
          return '140px';
        }else {
          return '90%';
        }
      }
    }
  };
</script>
<style lang="scss">
.nickname-tips {
  z-index: 40099!important;
}
.tips-icon {
  font-size: 14px;
  color: #999;
  margin-left: 5px;
  cursor: help;
}
</style>